module.exports = __webpack_public_path__ + "static/rest-api-07b7a38ce0094aa32b5be9f83fcaa474.png";